import { ActiveFilterType } from './types';

export const SidebarTabNames = {
  EDIT_CAMPAIGN: 'editCampaign',
  GENERAL: 'general',
  AGENT: 'agents',
  SQUADS: 'squads',
  PHONE_NUMBERS: 'customers',
  AMBIENCE_SETTINGS: 'ambienceSettings',
  ANALYSIS_SUMMARY: 'analysisSummary',
  SETTINGS: 'webhooks',
  SIP_TRUNK: 'sipTrunk',
  ONGOING_CALLS: 'calls',
  CALL_ANALYSIS: 'callAnalysis',
  STATISTICS: 'statistics',
};

export const CallAnalysisTabNames = {
  GENERAL: 'general',
  STATISTICS: 'statistics',
} as const;
export type CallAnalysisTabNames = (typeof CallAnalysisTabNames)[keyof typeof CallAnalysisTabNames];

export const SidebarSubTabFieldsMap: Record<string, string> = {
  title: SidebarTabNames.GENERAL,
  retryIntervalInMinutes: SidebarTabNames.GENERAL,
  retryMaxNumber: SidebarTabNames.GENERAL,
  retriesPerDay: SidebarTabNames.GENERAL,
  callSchedule: SidebarTabNames.GENERAL,
  reservedLimit: SidebarTabNames.GENERAL,
  agents: SidebarTabNames.AGENT,
  leadList: SidebarTabNames.PHONE_NUMBERS,
  followUpTemplate: SidebarTabNames.SETTINGS,
  analysisPlan: SidebarTabNames.CALL_ANALYSIS,
};

export const DEBOUNCED_SEND_INTERVAL = 2000;

export const USAGE_LIMIT_WARNING_THRESHOLD_SECONDS = 10 * 3600;

export const sipCredentialsMock = {
  authUsername: undefined,
  authPassword: undefined,
};

export const ActiveFilterEnum: Record<Uppercase<ActiveFilterType>, ActiveFilterType> = {
  'INBOUND-PHONE-CALL': 'inbound-phone-call',
  'OUTBOUND-PHONE-CALL': 'outbound-phone-call',
  'WEBSOCKET-CALL': 'websocket-call',
  'WEB-CALL': 'web-call',
  ALL: 'all',
};
